import React from 'react';
import { cn } from '../../utils/cn';
import type { BaseComponentProps } from '../../types/common';

export interface SpacerProps extends BaseComponentProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | number;
  direction?: 'horizontal' | 'vertical';
}

const spacerSizes = {
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
};

export const Spacer = React.forwardRef<HTMLDivElement, SpacerProps>(
  (
    {
      size = 'md',
      direction = 'vertical',
      className,
      testId,
      ...props
    },
    ref
  ) => {
    const sizeValue = typeof size === 'number' ? size : spacerSizes[size] || spacerSizes.md;
    
    const style = {
      [direction === 'horizontal' ? 'width' : 'height']: `${sizeValue}px`,
      flexShrink: 0,
    };

    const classes = cn(
      'block',
      {
        'w-full': direction === 'vertical',
        'h-full': direction === 'horizontal',
      },
      className
    );

    return (
      <div
        ref={ref}
        className={classes}
        style={style}
        data-testid={testId}
        aria-hidden="true"
        {...props}
      />
    );
  }
);

Spacer.displayName = 'Spacer';